// 仓库承运商账户
import TableList from "@components/templates/tablelist";
import { HttpGetAccountList } from "@/service/basicdata";
import { mapGetters } from "vuex";
import comIndex from './update'

export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_errorType: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpGetAccountList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'basicdataCarrierAccountUpdate',
                        params: { type: "add"},
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'basicdataCarrierAccountUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.operate_see', { defaultValue: '查看' }),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "basicdataCarrierAccountUpdate",
                        params: { type: "query" },
                        query: { id: params},
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'exportExcel':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/WarehouseCarrier/export', this.formData, 'download');
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:this.$t('global.common.operate_see', { defaultValue: '查看' }),
                show: this.handleAuth('fbb.shippinglabel.query'),
                params:id,
                operate:'query'
            },{
                label:this.$t('fbb.reserveinbound.edit', { defaultValue: '编辑' }),
                show: this.handleAuth('fbb.shippinglabel.edit'),
                params:id,
                operate:'edit'
            },]
        },
    },
    computed: {
        ...mapGetters('dictionary',['getBillcusWareList','getCarrierAllList']),
        ToolsData() {
            return [
                {
                    label: this.$t('global.common.operate_add', { defaultValue: "添加" }),
                    show: this.handleAuth('fbb.shippinglabel.add'),
                    operate: "add",
                    theme: "primary",
                },
                {
                    label: this.$t('global.common.export', { defaultValue: "导出" }),
                    show: this.handleAuth('fbb.shippinglabel.export'),
                    operate: "exportExcel",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    tag: 'vSelect',
                    key: 'EQ_warehouseId',
                    options: this.getBillcusWareList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    options: this.getCarrierAllList.map(item=>{
                        return {
                            value: item.value,
                            label: item.label
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$t('fbb.carrieraccount.shipping_account', { defaultValue: "Shipping账户" }),
                    tag: 'vInput',
                    key: 'EQ_carrierAccount',
                    show: true,

                },
                // {
                //     label: this.$t('fbb.carrieraccount.billing_account', { defaultValue: "Billing账户" }),
                //     tag: 'vInput',
                //     key: 'EQ_billingAccount',
                //     show: true,

                // },
                {
                    label: this.$t('fbb.bill.freeze_createdat', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.operate', { defaultValue: '操作' }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'changeOrderNo',
                    render:(h,{row})=>{
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.warehouseCode} ({row.warehouseTitle})</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
                    key: 'carrierCode',
                    // render: (h, { row }) => this.findRenderLabel(this.getCarrierAllList, row.id),
                },
                {
                    title: this.$t('fbb.carrieraccount.account_type', { defaultValue: '对接类型' }),
                    key: 'accountType',
                    render: (h, { row }) => {
                        let type = row.accountType == 0 ? 'post' : 'label';
                        return <div>{type}</div>
                    }
                },
                {
                    title: this.$t('fbb.carrieraccount.shipping_account', { defaultValue: "Shipping账户" }),
                    key: 'carrierAccount',
                },
                // {
                //     title: this.$t('fbb.carrieraccount.billing_account', { defaultValue: "Billing账户" }),
                //     key: 'billingAccount',
                // },
                {
                    title: this.$t('fbb.carrieraccount.channel_login_account', { defaultValue: '平台单登录账户' }),
                    key:'channelLabelAccount'
                },
                {
                    title: this.$t('fbb.carrieraccount.channel_shipper_code', { defaultValue: '平台单shipper Code' }),
                    key: 'channelLabelShipperCode'
                },
                {
                    title: this.$t('fbb.carrieraccount.label_account', { defaultValue: '非平台单登录账户' }),
                    key: 'labelAccount'
                },
                {
                    title: this.$t('fbb.carrieraccount.label_shipper_code', { defaultValue: '非平台单shipper Code' }),
                    key: 'labelShipperCode'
                },
                {
                    title: this.$t('fbb.bill.freeze_createdat', { defaultValue: "创建日期" }),
                    key: 'createdAt',
                    sortable: true
                },
            ];
        },

    },

};
